"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SaveScheduleButtonCms = void 0;
var SaveScheduleButtonCms = /** @class */ (function () {
    function SaveScheduleButtonCms() {
        this.updateInstallationLabel = 'Update installation info';
        this.addInstallationLabel = 'Add installation info';
    }
    return SaveScheduleButtonCms;
}());
exports.SaveScheduleButtonCms = SaveScheduleButtonCms;
//# sourceMappingURL=SaveScheduleButton.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/components/panels/ScheduleInstallPanel/SaveScheduleButton/SaveScheduleButton.cms.js
// module id = 969
// module chunks = 8